<nz-modal [(nzVisible)]="isVisible" [nzFooter]="null" [nzWidth]="'60vw'" [nzClosable]="false"
    (nzOnCancel)="handleCancel()" nzClassName="fullscreen-modal">
    <div class="modal-content" *nzModalContent>

        <nz-row class="custom-row" style="padding: 0px;">
            <!-- Left Column -->
            <nz-col [nzSpan]="24">
                <div class="content-box">
                    <button nz-button nzType="default" nzShape="circle" (click)="handleCancel()" class="close-button">
                        <nz-icon nzType="close" />
                    </button>
                    <div class="result-container">
                        <button nz-button nzType="default" class="quick-btn" (click)="openQuickApp('client')"> <nz-icon
                                nzType="plus" /> Client</button>
                        <button nz-button nzType="default" class="quick-btn" (click)="openQuickApp('project')"><nz-icon
                                nzType="plus" /> Project</button>
                        <button nz-button nzType="default" class="quick-btn" (click)="openQuickApp('task')"><nz-icon
                                nzType="plus" /> Task</button>
                        <button nz-button nzType="default" class="quick-btn" (click)="openQuickApp('event')"> <nz-icon
                                nzType="plus" /> Events</button>
                        <button nz-button nzType="default" class="quick-btn" (click)="openReport()"><nz-icon
                                nzType="line-chart" />Reports</button>
                    </div> 

                    <div class="search-container">

                        <nz-input-group [nzPrefix]="nzPrefixTemplate" [nzSuffix]="suffixTemplate" nzSize="large">
                            <input placeholder="Search {{searchByListSelected == 'all' ? '' : 'by ' + searchByListSelected}}" nz-input [(ngModel)]="searchValue"
                                (ngModelChange)="onChange($event)" [nzAutocomplete]="auto"
                                (keydown.enter)="onSearch()" />
                        </nz-input-group>
                        <ng-template #nzPrefixTemplate>
                            <nz-icon *ngIf="!isLoadingSearch" nzType="search" class="search-icon" />
                            <nz-spin *ngIf="isLoadingSearch" nzSimple class="search-icon"></nz-spin>
                        </ng-template>
                        <ng-template #suffixTemplate>
                            <i nz-icon *ngIf="searchValue" nzType="close-circle" class="clear-icon"
                                (click)="clearSearch()"></i>
                        </ng-template>
                        <nz-autocomplete #auto>
                            @for (group of searchListData; track group.key) {
                            <nz-auto-optgroup [nzLabel]="groupTitle"  *ngIf="(searchByListSelected === 'all' || searchByListSelected === group?.key) && group?.value?.length" 
                            [nzLabel]="groupTitle">
                                <ng-template #groupTitle>
                                    <strong> <span>
                                            Found {{ group?.key || 'Unknown'  }}
                                            <a class="more-link" href="javascript:void(0);" (click)="showMore(group)">({{group.value?.length || 0}})</a>
                                        </span></strong>
                                </ng-template>
                                @for (option of group.value; track option?.id) {
                                <nz-auto-option [nzLabel]="option?.title || ''" [nzValue]="option?.title || ''"
                                 (click)="redirectToConsole(option , group?.key)">

                                    <div class="search-item-wrapper">
                                        <div class="search-item-left">

                                            <nz-avatar nzIcon="apartment" class="search-item-avatar"
                                                *ngIf="group.key == 'client'" [nzSrc]="getIcon(option)"></nz-avatar>

                                            <nz-avatar nzIcon="project" class="search-item-avatar"
                                                *ngIf="group.key == 'project'" [nzSrc]="getIcon(option)"></nz-avatar>

                                            <nz-avatar nzIcon="reconciliation" class="search-item-avatar"
                                                *ngIf="group.key == 'task'" [nzSrc]="getIcon(option)"></nz-avatar>

                                            <nz-avatar nzIcon="reconciliation" class="search-item-avatar"
                                                *ngIf="group.key == 'event'" [nzSrc]="getIcon(option)"></nz-avatar>

                                            <strong> {{ option.name.length > 30 ? option.name.substring(0, 30) + '...' :
                                                option.name }}</strong>
                                            <span class="search-item-secondary" *ngIf="group.key == 'client'">
                                                ({{getWebsiteDomain(option)}})</span>
                                            <span class="search-item-secondary" *ngIf="group.key == 'task'">
                                                ({{option.project_name.length > 25 ? option.project_name.substring(0,
                                                25)
                                                + '...' : option.project_name}})
                                            </span>
                                            <span class="search-item-secondary" *ngIf="group.key == 'project'">
                                                ({{option.client_name}})
                                            </span>
                                            <span class="search-item-secondary" *ngIf="group.key == 'event'">
                                                ({{option.event_name}})
                                            </span>
                                        </div>
                                        <div class="search-item-right" nz-flex [nzJustify]="'flex-end'"
                                            [nzAlign]="'flex-end'">
                                            <nz-tag [nzColor]="'purple'" *ngIf="group.key == 'client' && option.address[0]?.region != null">
                                                {{getRegionName(option)}}
                                            </nz-tag>
                                            <nz-tag [nzColor]="'lime'" *ngIf="group.key == 'task' && option.task_status_name != null">
                                                {{option.task_status_name}}
                                            </nz-tag>
                                            <nz-tag [nzColor]="getProjectStatusColor(option.status_name)"
                                                *ngIf="group.key == 'project' && option.status_name != null">
                                                {{ option.status_name}}
                                            </nz-tag>

                                            <nz-tag>
                                                {{ formatIdToFourDigits(option.id, group.key) }}
                                            </nz-tag>
                                        </div>
                                    </div>

                                    <!-- <span class="certain-search-item-count">{{ option.id }} </span> -->
                                </nz-auto-option>
                                }
                            </nz-auto-optgroup>
                            }
                        </nz-autocomplete>

                    </div>

                    <div class="filter-by"> 
                        <p>Search on</p>
                        <nz-radio-group [(ngModel)]="searchByListSelected" [nzSize]="'large'" class="rounded-radio-group" (ngModelChange)="onSearchChange($event)">
                            <label *ngFor="let item of searchByList" 
                            nz-radio-button [nzValue]="item.value"><nz-icon [nzType]="item.icon" nzTheme="outline" /> {{item.name}}</label> 
                          </nz-radio-group> 
                    </div>




                    <!-- <div class="result-container">
        
        
                        <nz-card class="shadow card-rounded">
                          <h2><span nz-icon nzType="file-search" nzTheme="outline"></span> Recent Search </h2> 
                  
                          <ul nz-list [nzDataSource]="clients"  [nzRenderItem]="item" [nzNoResult]="noData">
                             
                            <ng-template #item let-item>
                                <nz-list-item   style="font-weight: bold;" >
                                    <a href="javascript:void(0)" (click)="onClientClick(item,item.type)">
                                      <span nz-icon [nzType]="item.icon" nzTheme="outline"></span> {{ item.name }}</a>
                                  </nz-list-item>
                            </ng-template>

                            <ng-template #noData>
                                <div class="noData text-muted text-center">
                                    <i nz-icon nzType="frown" nzTheme="outline"></i>
                                    <p >No Recent Data Found! </p>
                                </div>
                            </ng-template>
                        </ul>

                         
                          
                  
                        </nz-card>
                  
                  
                      </div> -->



                </div>
            </nz-col>

        </nz-row>

    </div>
</nz-modal>